import { render, staticRenderFns } from "./WaiverEventSpectator.vue?vue&type=template&id=473ad2a5"
import script from "./WaiverEventSpectator.vue?vue&type=script&lang=js"
export * from "./WaiverEventSpectator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports